import { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import Box from '@mui/material/Box'
import GlobalStyles from '@mui/material/GlobalStyles'

/**
 * A document for the browser's own print dialog.
 *
 * Rendered beside the app rather than inside it, hidden on screen, and while
 * printing the app is hidden instead — so the page prints only this, whatever
 * layout, drawers or sticky footers are on screen.
 */
export default function PrintPortal( { children }: { children: ReactNode } ) {
	return createPortal(
		<>
			<GlobalStyles
				styles={{
					'@media screen': { '.print-document': { display: 'none' } },
					'@media print': {
						'#root': { display: 'none !important' },
						'.print-document': { display: 'block' },
						'@page': { margin: '12mm' },
					},
				}}
			/>
			<Box
				className="print-document"
				sx={{
					'color': '#000',
					'bgcolor': '#fff',
					'fontFamily': 'Helvetica, Arial, sans-serif',
					'fontSize': '11pt',
					'& table': { width: '100%', borderCollapse: 'collapse' },
					'& th, & td': { border: '1px solid #999', px: '6px', py: '4px', textAlign: 'left', verticalAlign: 'top' },
					'& th': { bgcolor: '#eee', fontSize: '9pt', textTransform: 'uppercase' },
					'& .num': { textAlign: 'right', whiteSpace: 'nowrap' },
					'& .mono': { fontFamily: 'Menlo, Consolas, monospace' },
				}}
			>
				{children}
			</Box>
		</>,
		document.body,
	)
}
